import { lighten, makeStyles } from "@material-ui/core/styles";
import { BLUE_EIGHT, WHITE } from "../../theme";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    width: "100%",
    height: "100%",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  actionButton: {
    height: 15,
    width: 35,
    border: "1px solid #006E7D",
    borderRadius: "15px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    cursor: "pointer",

    "& .MuiSvgIcon-root": {
      color: "#006E7D",
    },
  },

  thead: {
    backgroundColor: BLUE_EIGHT,
    color: WHITE,
    "& .MuiTableSortLabel-root": {
      color: `${WHITE} !important`,
      fontWeight: "bold !important",
    },
    "& .MuiSvgIcon-root": {
      color: `${WHITE} !important`,
    },
  },
}));

export const useToolbarStyles = makeStyles((theme) => ({
  root: {
    border: "1px solid black",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));
